"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const getFont_1 = __importDefault(require("./utils/getFont"));
const getColor_1 = __importDefault(require("./utils/getColor"));
const InputField = styled_components_1.default.input `
  ${getFont_1.default}
  color: ${getColor_1.default};
  -webkit-text-fill-color: ${getColor_1.default};
  outline: none;
  border: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  background: transparent;

  &::placeholder {
    color: ${({ theme, isDisabled }) => isDisabled ? theme.colorDisabled : theme.colorPlaceholder};
    -webkit-text-fill-color: ${({ theme, isDisabled }) => isDisabled ? theme.colorDisabled : theme.colorPlaceholder};
  }
  cursor: ${({ isDisabled }) => isDisabled && 'not-allowed'};
`;
InputField.displayName = 'InputField';
exports.default = InputField;
